import { AxiosRequestConfig } from 'axios';
import { resetPassword } from '@store/modules/reset-password';

export function passwordResetKeyHeader(config: AxiosRequestConfig): AxiosRequestConfig {
	const passwordResetKey = {
		'password-reset-key': resetPassword.passwordResetKey
	};
	config.headers = { ...config.headers, ...passwordResetKey };
	return config;
}
